<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <app-empty-check-out-toolbar [number]="this.number" [isReadOnly]="isReadOnly" [isSubmitting]="isSubmitting"
            [isLoading]="isLoading" (cancelClick)="cancel()" (save)="onSaveClick($event)" (shuntMoveClick)="addShuntMove()"
            [action]="this.emptyCheckOut.actions">
        </app-empty-check-out-toolbar>
    </div>
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'appointment-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" height="80vh">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
                            <span>Check-Out Details</span>
                            <span class="text-muted fs-5">
                                @if (this.number) {
                                    ID: {{ this.emptyCheckOut.numberWithPrefix }}
                                }
                            </span>
                        </div>
                        <div class="card-body">
                            @if (this.number) {
                                <div class="row mb-3">
                                    <div class="col-6">
                                        <strong class="me-2">Status: </strong>
                                        <span class="badge" [ngClass]="getBadgeClass(this.emptyCheckOut.status)">
                                            {{ this.emptyCheckOut.status | emptyCheckOutStatus }}
                                        </span>
                                    </div>
                                    <div class="col-6">
                                        @if (this.emptyCheckOut.emptyCheckInNumber) {
                                            <div>
                                                <strong class="me-2">Empty Trailer: </strong>
                                                <a [routerLink]="`/inbound/empty-check-ins/details/${this.emptyCheckOut.emptyCheckInNumber}`"
                                                    class="text-decoration-none">{{ this.emptyCheckOut.emptyCheckInNumber }}</a>
                                            </div>
                                        }
                                        @if (this.emptyCheckOut.appointmentNumber) {
                                            <div>
                                                <strong class="me-2">Inbound Appointment: </strong>
                                                <a [routerLink]="`/inbound/appointments/details/${this.emptyCheckOut.appointmentNumber}`"
                                                    class="text-decoration-none">{{ this.emptyCheckOut.appointmentNumber }}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Carrier: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="emptyCheckOut.carrierId" [dataSource]="carrierDataSource"
                                        displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                        stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Carrier is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Warehouse:</label>
                                    <dx-select-box value="HDC Brampton" [items]="['HDC Brampton']" stylingMode="filled"
                                        [readOnly]="isReadOnly" placeholder="Select Warehouse">
                                    </dx-select-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Trailer Type:*</label>
                                    <dx-select-box [(value)]="emptyCheckOut.trailerType" [items]="trailerTypeOptions"
                                        valueExpr="value" displayExpr="text" stylingMode="filled"
                                        placeholder="Select Trailer Type" [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Trailer Type is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Trailer Number:*</label>
                                    <dx-text-box stylingMode="filled" [(value)]="emptyCheckOut.trailerNumber"
                                        maxLength="100" placeholder="Enter trailer number" [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Trailer Number is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Driver Name:</label>
                                    <dx-text-box stylingMode="filled" [(value)]="emptyCheckOut.driverName" maxLength="200"
                                        placeholder="Enter driver name" [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="custom" message="Driver Name is required"
                                                [validationCallback]="customValidator"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Tractor #:</label>
                                    <dx-text-box stylingMode="filled" [(value)]="emptyCheckOut.tractor" maxLength="100"
                                        placeholder="Enter tractor number" [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="custom" message="Tractor is required"
                                                [validationCallback]="customValidator"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            @if (isLoadedVariant) {
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label">Shipment #:</label>
                                        <dx-tag-box [(value)]="emptyCheckOut.shipments"
                                            [dataSource]="shipmentDataSource"
                                            displayExpr="logisticalGroup" valueExpr="logisticalGroup"
                                            [searchEnabled]="true" [showClearButton]="true" stylingMode="filled"
                                            placeholder="Shipment #" [readOnly]="isReadOnly">
                                        </dx-tag-box>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Seal Number:*</label>
                                        <dx-text-box stylingMode="filled" [(value)]="emptyCheckOut.sealNumber" maxLength="100"
                                            placeholder="Enter seal number" [readOnly]="isReadOnly">
                                            <dx-validator>
                                                <dxi-validation-rule type="custom" message="Seal Number is required"
                                                    [validationCallback]="customValidator"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                            } @else {
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label">Is trailer empty:</label>
                                        <dx-select-box [(value)]="emptyCheckOut.isTrailerEmpty" [items]="yesNoOptions"
                                            valueExpr="value" displayExpr="text" stylingMode="filled"
                                            placeholder="Select..." [readOnly]="isReadOnly">
                                            <dx-validator>
                                                <dxi-validation-rule type="custom" message="Trailer empty selection is required"
                                                    [validationCallback]="customValidator"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                    @if (emptyCheckOut.isTrailerEmpty !== null && !emptyCheckOut.isTrailerEmpty) {
                                        <div class="col-md-6">
                                            <label class="form-label">Seal Number:*</label>
                                            <dx-text-box stylingMode="filled" [(value)]="emptyCheckOut.sealNumber" maxLength="100"
                                                placeholder="Enter seal number" [readOnly]="isReadOnly">
                                                <dx-validator>
                                                    <dxi-validation-rule type="required"
                                                        message="Seal Number is required"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <app-notes
                        [entityId]="number"
                        [noteType]="NoteType.EmptyCheckOut"
                        [canCreate]="true"
                        (noteSaved)="onNoteSaved()"
                        (noteCanceled)="onNoteCanceled()"
                    ></app-notes>
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>

    <shunt-move-form [(visible)]="isAddShuntMovePopupOpened" (onSave)="onShuntMovePopupSaveClick()" [titlePrefix]="'Add'"></shunt-move-form>
</div>